import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import './Header.css';
import logo from '../assets/Vavelle & Co. horizontal.png'; // Import the logo image

function Header() {
  const [menuOpen, setMenuOpen] = useState(false);
  const location = useLocation(); // Get the current location

  return (
    <><header className="sticky top-0 z-1000! ztop">
        {/* Top Red Bar */}
        <div className="top-bar">
          <Link
              to="https://wa.me/6281398253186?text=Saya tertarik sewa mobil"
              className={`hover:underline ${location.pathname.includes('/') ? 'active' : ''}`}
            >Call us for booking or a quote!</Link>          
        </div>

        {/* Main Navigation */}
        <nav className="navbar">
          <div className="logo-container">
          <Link to="/"><img src={logo} alt="Vavelle & Co Rental Mobil Logo" className="logo" /></Link>
          </div>

          {/* Hamburger Menu for Mobile */}
          <div className="hamburger" onClick={() => setMenuOpen(!menuOpen)}>
            ☰
          </div>

          {/* Navigation Links */}
          <ul className={`nav-menu ${menuOpen ? 'open' : ''}`}>
            <li className="nav-item">
              <Link to="/" className={location.pathname === '/' ? 'active' : ''}>Beranda</Link>
            </li>
            <li className="nav-item">
              <Link to="/kendaraan" className={location.pathname.includes('/kendaraan') ? 'active' : ''}>Kendaraan</Link>
            </li>            
            <li className="nav-item">
              <Link to="/faq" className={location.pathname.includes('/faq') ? 'active' : ''}>FAQ</Link>
            </li>          
            <li className="nav-item">
              <Link to="/tentang-kami" className={location.pathname.includes('/tentang-kami') ? 'active' : ''}>Tentang</Link>
            </li>                  
            <li className="nav-item">
              <Link to="/tnc" className={location.pathname.includes('/tnc') ? 'active' : ''}>Syarat & Ketentuan</Link>
            </li>
            {/* <li className="nav-item">
              <Link to="/Lokasi" className={location.pathname.includes('/Lokasi') ? 'active' : ''}>Lokasi</Link>
            </li> */}
            {/* <li className="nav-item">
              <Link to="/pembayaran" className={location.pathname.includes('/pembayaran') ? 'active' : ''}>Pembayaran</Link>
            </li> */}
            <li className="nav-item">
              <Link to="/booking" className={location.pathname.includes('/booking') ? 'active' : ''}>Booking</Link>
            </li>
          </ul>
        </nav>
      </header></>
  );
}

export default Header;
